import React, { useRef } from "react";
import { FixedSizeList as List } from "react-window";
import { default as ReactSelect } from "react-select";
import { withRouter } from "react-router";
import { components } from "react-select";
import { Col, Row } from "react-bootstrap";

const OPTION_HEIGHT = 40;
const ROWS = 6;

const MenuList = ({ options, children, getValue }) => {
  const [value] = getValue();
  const initialOffset =
    options.indexOf(value) !== -1
      ? Array.isArray(children) && children.length >= ROWS
        ? options.indexOf(value) >= ROWS
          ? options.indexOf(value) * OPTION_HEIGHT - OPTION_HEIGHT * 5
          : 0
        : 0
      : 0;

  return Array.isArray(children) ? (
    <List
      height={
        children.length >= ROWS
          ? OPTION_HEIGHT * ROWS
          : children.length * OPTION_HEIGHT
      }
      itemCount={children.length}
      itemSize={OPTION_HEIGHT}
      initialScrollOffset={initialOffset}
    >
      {({ style, index }) => {
        return <div style={style}>{children[index]}</div>;
      }}
    </List>
  ) : (
    <div>{children}</div>
  );
};

const Option = (props) => {
  return (
    <div>
      <components.Option style={{ display: "inline-block" }} {...props}>
        <Row className="d-flex justify-content-betweem align-items-center">
          <Col xl={1} lg={1} md={1} sm={1} xs="auto">
            <input
              type="checkbox"
              checked={props.isSelected}
              onChange={() => null}
              style={{ display: "inline-block" }}
            />
          </Col>
          <Col xl={9} lg={9} md={9} sm={9}>
            <label>{props.label}</label>
          </Col>
        </Row>
      </components.Option>
    </div>
  );
};

const CaretDownIcon = () => {
  return <i className="fas fa-angle-down" />;
};

const ErrorIcon = () => {
  return (
    <i style={{ color: "red" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ margin: "auto", display: "block" }}
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-exclamation-circle"
        viewBox="0 0 16 16"
      >
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 4.995z" />
      </svg>
    </i>
  );
};
const SuccessIcon = () => {
  return (
    <i style={{ color: "green" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        style={{ margin: "auto", display: "block" }}
        width="16"
        height="16"
        fill="currentColor"
        class="bi bi-check"
        viewBox="0 0 16 16"
      >
        <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z" />
      </svg>
    </i>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      {!props.selectProps.isValid && !props.selectProps.isInvalid && (
        <CaretDownIcon />
      )}
      {props.selectProps.isValid && <SuccessIcon />}
      {props.selectProps.isInvalid && <ErrorIcon />}
    </components.DropdownIndicator>
  );
};

const MultiValue = (props) => {
  if (props.index !== 0) {
    return null;
  }

  const selectedCount = props.selectProps.value.length;

  return (
    <div className="d-flex flex-wrap justify-content-center align-items-center text-justify">
      {props.selectProps.value[0].value === "<SELECT_ALL>" &&
        `Todos seleccionados`}
      {props.selectProps.value[0].value !== "<SELECT_ALL>" &&
        `${selectedCount} opci${selectedCount > 1 ? "o" : "ó"}n${
          selectedCount > 1 ? "es" : ""
        } seleccion${selectedCount > 1 ? "adas" : "ada"}`}
    </div>
  );
};

const MultiSelect = (props) => {
  const valueRef = useRef();
  valueRef.current = props.value;

  const { isValid, isInvalid } = props;

  const customStyles = {
    control: (base) => ({
      ...base,
      paddingLeft: "0.5rem",
      paddingRight: "0.5rem",
      color: "#495057",
      borderColor: isValid ? "green" : isInvalid ? "red" : "#ced4da",
      "&:hover": {
        borderColor: isValid ? "green" : isInvalid ? "red" : "#ced4da",
      },
      maxHeight: 40,
      minHeight: 40,
      borderRadius: 50,
      marginBottom: "none",
    }),
    valueContainer: (provided) => ({
      ...provided,
      textOverflow: "ellipsis",
      maxWidth: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
    }),
    option: (opt) => ({
      ...opt,
      backgroundColor: "none",
      color: "black",
      border: null,
    }),
    singleValue: (state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";

      return { opacity, transition };
    },
  };

  const selectAllOption = {
    value: "<SELECT_ALL>",
    label: "Seleccionar todo",
  };

  const isSelectAllSelected = () =>
    valueRef.current &&
    props.options &&
    valueRef.current.length === props.options.length;

  const isOptionSelected = (option) =>
    (valueRef.current &&
      valueRef.current.some(({ value }) => value === option.value)) ||
    isSelectAllSelected();

  const getOptions = () => [selectAllOption, ...props.options];

  const getValue = () =>
    props.options.length > 0
      ? isSelectAllSelected()
        ? [selectAllOption]
        : props.value
      : props.value;

  const onChange = (newValue, actionMeta) => {
    const { action, option, removedValue } = actionMeta;

    if (action === "select-option" && option.value === selectAllOption.value) {
      props.onChange(props.options, actionMeta);
    } else if (
      (action === "deselect-option" &&
        option.value === selectAllOption.value) ||
      (action === "remove-value" &&
        removedValue.value === selectAllOption.value)
    ) {
      props.onChange([], actionMeta);
    } else if (
      actionMeta.action === "deselect-option" &&
      isSelectAllSelected()
    ) {
      props.onChange(
        props.options.filter(({ value }) => value !== option.value),
        actionMeta
      );
    } else {
      props.onChange(newValue || [], actionMeta);
    }
  };

  return (
    <>
      <ReactSelect
        isOptionSelected={isOptionSelected}
        options={getOptions()}
        value={getValue()}
        // onChange={props.onChange}
        onChange={onChange}
        hideSelectedOptions={false}
        closeMenuOnSelect={false}
        isMulti
        components={{
          Option,
          MenuList,
          MultiValue,
          DropdownIndicator,
        }}
        styles={customStyles}
        isDisabled={props.isDisabled}
        isValid={props.isValid}
        isInvalid={props.isInvalid}
        onBlur={props.onBlur ? props.onBlur() : null}
        isSearchable={true}
        placeholder="Seleccionar..."
        openMenuOnClick={false}
      />
    </>
  );
};

export default withRouter(MultiSelect);
